export default __webpack_public_path__ + "static/media/plus_white.07f46e16.svg";